export const SCREEN_XL = 1280;
export const SCREEN_LG = 992;
export const SCREEN_MD = 768;
export const SCREEN_SM = 576;
export const SCREEN_XS = 375;
export const SCREEN_XXS = 345;
